import axios from 'axios';
import qs from 'qs';
import {getSavedMeta} from 'COMMON_UTILITY/marketing-meta';

const MAX_LENGTH = 300;
const domain = window.location.origin;

export const requestBid = axios.create({
  baseURL: domain + '/api-cms/frontend/bid',
  headers: {'Accept-Language': document.documentElement.lang},
  transformRequest: [
    function (body) {
      if (body.data) {
        let context = domain + window.location.pathname;
        body.data.context = context.substring(0, MAX_LENGTH);
        body.data.referer = document.referrer.substring(0, MAX_LENGTH) || undefined;
        body.data.meta = getSavedMeta('utms');
      }
      return qs.stringify(body);
    },
  ],
});

export const request = axios.create({
  baseURL: domain + '/api-cms/frontend',
  headers: {'Accept-Language': document.documentElement.lang},
});
